<script setup lang="ts">
    const props = defineProps<{
        error: { statusCode?: number; message?: string; statusMessage?: string };
    }>();

    const messages = useErrorPageTranslations();

    const title = computed(() => String(props.error?.statusCode || messages.title));

    const reload = () => window.location.reload();
</script>

<template>
    <div class="fixed inset-0 flex items-center justify-center bg-blue-gray-50 p-6 font-inter">
        <div class="w-full max-w-sm rounded-2xl border border-blue-gray-200 bg-white px-8 py-10 text-center shadow-popup">
            <img
                class="mx-auto mb-5 block rounded-xl"
                src="/trustup-app-icon.png"
                alt="TrustUp Pro"
                width="56"
                height="56"
            />

            <h1 class="mb-2 font-bricolage text-xl font-bold text-blue-gray-900">{{ title }}</h1>
            <p class="mb-6 text-sm leading-relaxed text-slate-500">{{ messages.text }}</p>

            <button
                class="inline-flex h-11 items-center justify-center rounded-lg bg-trustup px-5 text-sm font-semibold text-blue-gray-900 outline-blue-gray-900 outline-offset-2 transition-colors hover:bg-yellow-400 focus-visible:outline focus-visible:outline-2"
                type="button"
                @click="reload"
            >
                {{ messages.reload }}
            </button>
        </div>
    </div>
</template>
